import React, { useState } from 'react';
import {
  TextField,
  Box,
  Grid2,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slider,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const FiltersPopup = ({ isFiltersOpen, handleCloseFilters, onSubmitFilters, onResetFilters }) => {
  const initialFormData = {
    min_square_footage: '', // Minimum square footage
    max_square_footage: '', // Maximum square footage
    rooms: '',
  };

  const [formData, setFormData] = useState(initialFormData);

  // Handle slider change for min and max square footage
  const handleSliderChange = (event, newValue) => {
    setFormData({
      ...formData,
      min_square_footage: newValue[0],
      max_square_footage: newValue[1],
    });
  };

  // Handle min/max input changes for square footage
  const handleMinMaxInputChange = (e, field) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [field]: Number(value), // Ensure input is treated as a number
    }));
  };

  // Handle other form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Reset the form
  const handleResetFilters = () => {
    setFormData({
      ...initialFormData,
      min_square_footage: '', // Reset to no filter applied
      max_square_footage: '', // Reset to no filter applied
    });
  };

  const handleApplyFilters = () => {
    // Check if any filters have been applied by comparing formData with initialFormData
    const isFiltersApplied = Object.keys(formData).some(
      (key) => formData[key] !== initialFormData[key]
    );

    if (isFiltersApplied) {
      // If filters are applied, submit the filters
      onSubmitFilters(formData); // Call onSubmitFilters
      console.log('formData', formData);
      handleCloseFilters(); // Close the popup afterward
    } else {
      // Optionally, show a message if no filters are applied
      console.log('No filters applied');
      handleCloseFilters(); // Close the popup afterward
    }
  };

  return (
    <Dialog open={isFiltersOpen} onClose={handleCloseFilters} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          borderBottom: '1px solid',
          borderColor: (theme) => theme.palette.grey[300],
          marginBottom: 2,
        }}
      >
        <Box 
          display="flex" 
          alignItems="center" 
          justifyContent="space-between" 
          position="relative"
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseFilters}
            sx={{
              position: 'absolute',
              left: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" textAlign="center" flexGrow={1}>
            Additional Filters
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Grid2 container spacing={2}>
          {/* Square Footage Range Slider */}
          <Grid2 item xs={12}>
            <Typography gutterBottom>Square Footage Range</Typography>
            <Slider
              value={[formData.min_square_footage, formData.max_square_footage]}
              onChange={handleSliderChange}
              valueLabelDisplay="auto"
              min={10}
              max={1000}
              step={5}
            />
            <Grid2 container spacing={2}>
              <Grid2 item xs={6}>
                <TextField
                  label="Min Square Footage"
                  value={formData.min_square_footage}
                  onChange={(e) => handleMinMaxInputChange(e, 'min_square_footage')}
                  fullWidth
                  type="number"
                  margin="normal"
                />
              </Grid2>
              <Grid2 item xs={6}>
                <TextField
                  label="Max Square Footage"
                  value={formData.max_square_footage}
                  onChange={(e) => handleMinMaxInputChange(e, 'max_square_footage')}
                  fullWidth
                  type="number"
                  margin="normal"
                />
              </Grid2>
            </Grid2>
          </Grid2>

          {/* Rooms Input */}
          <Grid2 item xs={12} sm={4}>
            <TextField
              label="Rooms"
              name="rooms"
              type="number"
              value={formData.rooms}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
          </Grid2>
        </Grid2>
      </DialogContent>

      <DialogActions
        sx={{
          borderTop: '1px solid',
          borderColor: (theme) => theme.palette.grey[300],
          padding: 2,
        }}
      >
        <Grid2 container spacing={2}>
          <Grid2 item xs={6}>
            <Button
              type="submit"
              variant="outlined"
              onClick={() => { handleResetFilters(); onResetFilters(); }}
              color="secondary"
              fullWidth
            >
              Clear all
            </Button>
          </Grid2>
          <Grid2 item xs={6}>
            <Button
              type="submit"
              variant="contained"
              onClick={handleApplyFilters}
              color="primary"
              fullWidth
            >
              Apply
            </Button>
          </Grid2>
        </Grid2>
      </DialogActions>
    </Dialog>
  );
};

export default FiltersPopup;